import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

export default function UyelikVeKullanimSartlariPage() {
  return (
    <div className="min-h-screen bg-gray-50 font-poppins">
      <Header />

      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm p-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">
              Üyelik ve Kullanım Şartları Sözleşmesi
            </h1>

            <div className="space-y-8 text-gray-600">
              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">1. Taraflar ve Konu</h2>
                <div className="bg-gold-50 p-6 rounded-lg">
                  <p className="mb-4">
                    <strong>İşbu sözleşme aşağıdaki taraflar arasında imzalanmıştır:</strong>
                  </p>
                  <div className="space-y-2">
                    <p><strong>SİTE SAHİBİ:</strong> Emin Kuyumculuk</p>
                    <p><strong>Adres:</strong> Kamil Ocak Mah. Divrik Cad. 45/A Keçiören / ANKARA</p>
                    <p><strong>Telefon:</strong> 0531 603 68 91</p>
                    <p><strong>E-posta:</strong> info@eminkuyumculuk.com.tr</p>
                    <p><strong>ÜYE:</strong> www.eminkuyumculuk.com.tr sitesine üye olan gerçek/tüzel kişi</p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">2. Üyelik Koşulları</h2>
                <div className="space-y-4">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-2">Gerekli Şartlar</h3>
                    <ul className="list-disc list-inside text-sm space-y-1">
                      <li>18 yaşını doldurmuş olmak (18 yaş altı için veli onayı gereklidir)</li>
                      <li>Doğru ve güncel bilgiler sağlamak</li>
                      <li>Geçerli bir e-posta adresi ve telefon numarası vermek</li>
                      <li>Bu sözleşme şartlarını kabul etmek</li>
                    </ul>
                  </div>
                  
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-2">Üyelik Süreci</h3>
                    <ul className="list-disc list-inside text-sm space-y-1">
                      <li>Üyelik formu doldurulur</li>
                      <li>E-posta doğrulama yapılır</li>
                      <li>Hesap aktif hale gelir</li>
                      <li>Üye alışveriş yapmaya başlayabilir</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">3. Üye Hakları</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gold-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-2">Alışveriş Hakları</h3>
                    <ul className="list-disc list-inside text-sm space-y-1">
                      <li>Ürünleri inceleme ve satın alma</li>
                      <li>Özel üye fiyatlarından yararlanma</li>
                      <li>Kampanya ve indirimlerden haberdar olma</li>
                      <li>Sipariş geçmişini görüntüleme</li>
                    </ul>
                  </div>
                  
                  <div className="bg-gold-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-2">Hesap Hakları</h3>
                    <ul className="list-disc list-inside text-sm space-y-1">
                      <li>Kişisel bilgileri güncelleme</li>
                      <li>Şifre değiştirme</li>
                      <li>Üyeliği sonlandırma</li>
                      <li>Sipariş takibi yapma</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">4. Üye Yükümlülükleri</h2>
                <div className="space-y-4">
                  <div className="bg-amber-50 p-4 rounded-lg border-l-4 border-amber-400">
                    <h3 className="font-semibold text-amber-800 mb-2">Bilgi Güvenliği</h3>
                    <ul className="list-disc list-inside text-sm text-amber-700 space-y-1">
                      <li>Kullanıcı adı ve şifreyi gizli tutmak</li>
                      <li>Hesabın yetkisiz kullanımını engellemek</li>
                      <li>Şüpheli durumları derhal bildirmek</li>
                      <li>Doğru iletişim bilgileri sağlamak</li>
                    </ul>
                  </div>
                  
                  <div className="bg-amber-50 p-4 rounded-lg border-l-4 border-amber-400">
                    <h3 className="font-semibold text-amber-800 mb-2">Kullanım Kuralları</h3>
                    <ul className="list-disc list-inside text-sm text-amber-700 space-y-1">
                      <li>Site kurallarına uymak</li>
                      <li>Yasalara aykırı işlem yapmamak</li>
                      <li>Diğer üyelere saygılı davranmak</li>
                      <li>Sistem güvenliğini tehlikeye atmamak</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">5. Hesap Güvenliği</h2>
                <div className="space-y-3">
                  <p>
                    <strong>Şifre Güvenliği:</strong> Üyeler hesap şifrelerini güvenli tutmakla yükümlüdür. 
                    Şifrenizi kimseyle paylaşmayın ve düzenli olarak değiştirin.
                  </p>
                  <p>
                    <strong>Yetkisiz Erişim:</strong> Hesabınızda yetkisiz erişim tespit etmeniz halinde 
                    derhal bize bildirin.
                  </p>
                  <p>
                    <strong>Sorumluluk:</strong> Hesabınızdan yapılan tüm işlemlerden sorumlusunuz.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">6. Üyelik Iptali</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-3">Üye Tarafından İptal</h3>
                    <ul className="list-disc list-inside text-sm space-y-2">
                      <li>Hesap ayarlarından üyelik iptal edilebilir</li>
                      <li>E-posta ile iptal talebinde bulunabilir</li>
                      <li>Bekleyen siparişler tamamlanır</li>
                      <li>Kişisel veriler KVKK uyarınca işlenir</li>
                    </ul>
                  </div>
                  
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-3">Site Tarafından İptal</h3>
                    <ul className="list-disc list-inside text-sm space-y-2">
                      <li>Sözleşme ihlali durumunda</li>
                      <li>Yasadışı faaliyetler tespit edilirse</li>
                      <li>Sahte bilgi verilmesi halinde</li>
                      <li>Önceden e-posta ile bildirim yapılır</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">7. Kişisel Verilerin Korunması</h2>
                <p>
                  Üyelik sürecinde toplanan kişisel veriler KVKK Aydınlatma Metnimiz kapsamında işlenir. 
                  Detaylı bilgi için KVKK Aydınlatma Metnimizi inceleyebilirsiniz.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">8. İletişim İzinleri</h2>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-gray-800 mb-2">Bilgilendirme E-postaları</h3>
                  <ul className="list-disc list-inside text-sm space-y-1">
                    <li>Sipariş durumu bildirimleri (zorunlu)</li>
                    <li>Hesap güvenliği uyarıları (zorunlu)</li>
                    <li>Kampanya ve promosyon e-postaları (isteğe bağlı)</li>
                    <li>Ürün önerileri ve haberler (isteğe bağlı)</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">9. Sözleşme Değişiklikleri</h2>
                <div className="space-y-3">
                  <p>
                    Emin Kuyumculuk, bu sözleşmeyi tek taraflı olarak değiştirme hakkını saklı tutar. 
                    Değişiklikler:
                  </p>
                  <ul className="list-disc list-inside ml-4 space-y-1">
                    <li>Web sitesinde yayınlanır</li>
                    <li>E-posta ile üyelere bildirilir</li>
                    <li>Yayın tarihinden itibaren geçerli olur</li>
                    <li>Kabul etmeyen üyeler üyeliği sonlandırabilir</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">10. Sorumluluk ve Garanti</h2>
                <div className="space-y-3">
                  <p>
                    <strong>Site Sorumluluğu:</strong> Teknik arıza ve bakım durumlarında site 
                    geçici olarak erişilemez olabilir.
                  </p>
                  <p>
                    <strong>Üye Sorumluluğu:</strong> Üyeler hesaplarından yapılan tüm işlemlerden 
                    ve verdikleri bilgilerin doğruluğundan sorumludur.
                  </p>
                  <p>
                    <strong>Force Majeure:</strong> Doğal afetler, savaş, grev gibi öngörülemeyen 
                    durumlardan taraflar sorumlu değildir.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">11. Uyuşmazlık Çözümü</h2>
                <p>
                  Bu sözleşmeden doğacak uyuşmazlıklarda Ankara Mahkemeleri ve İcra Müdürlükleri 
                  yetkilidir. Tüketici üyeler için Tüketici Hakem Heyetleri ve Tüketici Mahkemeleri 
                  yetkilidir.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">12. Yürürlük</h2>
                <p>
                  Bu sözleşme, üye tarafından "Kabul Ediyorum" butonuna basılması ile yürürlüğe girer 
                  ve üyelik süresi boyunca geçerliliğini korur.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">13. İletişim</h2>
                <div className="bg-gold-50 p-6 rounded-lg">
                  <p className="text-gray-600 mb-4">
                    Üyelik ve sözleşme ile ilgili sorularınız için:
                  </p>
                  <div className="space-y-2 text-gray-700">
                    <p><strong>Emin Kuyumculuk</strong></p>
                    <p><strong>Adres:</strong> Kamil Ocak Mah. Divrik Cad. 45/A Keçiören / ANKARA</p>
                    <p><strong>Telefon:</strong> 0531 603 68 91</p>
                    <p><strong>E-posta:</strong> info@eminkuyumculuk.com.tr</p>
                    <p><strong>Çalışma Saatleri:</strong> Pazartesi - Cumartesi 09:00 - 19:00</p>
                  </div>
                </div>
              </section>

              <div className="bg-amber-50 p-4 rounded-lg border-l-4 border-amber-400">
                <p className="text-sm text-amber-800">
                  <strong>Sözleşme Tarihi:</strong> {new Date().toLocaleDateString('tr-TR')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}